import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import UiUx from "./assets/images/Ui-Ux Logo.png";
import Coding from "./assets/images/Coding Logo.png";
import Maintainance from "./assets/images/Maintainance Logo.png";

const Services = () => {
  return (
    <Container>
      <section id="services" className="pt-5 px-5">
        <h3 className="mb-5">SERVICES</h3>
        <Container className="text-center">
          <Row>
            <Col lg={4}>
              <img src={UiUx} alt="Ui-Ux logo" width="70%" className="mb-3" />
              <h3>UI/UX Design</h3>
            </Col>
            <Col lg={4}>
              <img
                src={Coding}
                alt="Front-end web development logo"
                width="70%"
                className="mb-3"
              />
              <h3>Front End Web Development</h3>
            </Col>
            <Col lg={4}>
              <img
                src={Maintainance}
                alt="Maintainance logo"
                width="70%"
                className="mb-3"
              />
              <h3>Update and Maintainance</h3>
            </Col>
          </Row>
        </Container>
      </section>
    </Container>
  );
};

export default Services;
